import classNames from 'classnames';
import type { ReactNode } from 'react';
import styled, { keyframes } from 'styled-components';

import { fadeIn } from '@sorare/core/src/atoms/animations/keyframes';
import { Horizontal, Vertical } from '@sorare/core/src/atoms/layout/flex';
import { BrandL, LabelL } from '@sorare/core/src/atoms/typography';
import { Fan } from '@sorare/core/src/components/animations/Fan';

const translateAnimation = (translateAmount: string) => keyframes`
  0% {
    transform: translateY(${translateAmount});
  }
  100% {
    transform: translateY(0px);
  }
`;

const Root = styled(Vertical).attrs({ center: true })`
  --image-size: calc(22 * var(--unit));
  gap: calc(6 * var(--unit));
`;
const ImgsArea = styled(Horizontal).attrs({ center: true })`
  position: relative;
  isolation: isolate;
  transform: translateY(60px);
  flex-wrap: wrap;

  &.translate {
    animation: ${translateAnimation('60px')} 0.6s var(--ease-in-out-quart)
      forwards;
    animation-delay: 0.5s;
  }
`;

const TextWrapper = styled(Vertical).attrs({ gap: 2, center: true })`
  transform: translateY(150px);
  &.translate {
    animation: ${translateAnimation('150px')} 0.65s var(--ease-in-out-quart)
      forwards;
    animation-delay: 0.55s;
  }
`;
const Title = styled(BrandL)`
  opacity: 0;
  animation: ${fadeIn} 0.65s var(--ease-in-out-quart) forwards;
  animation-delay: 0.55s;
`;
const Subtitle = styled(LabelL)`
  opacity: 0;
  animation: ${fadeIn} 0.65s var(--ease-in-out-quart) forwards;
  animation-delay: 0.6s;
`;

type Props = {
  featuredContent: ReactNode;
  title: ReactNode;
  subtitle: ReactNode;
};
export const TaskResultsPreClaimStoryTemplate = ({
  featuredContent,
  title,
  subtitle,
}: Props) => {
  return (
    <Root className="text-center">
      <Vertical gap={2}>
        <ImgsArea className={classNames({ translate: true })}>
          <Fan>{featuredContent}</Fan>
        </ImgsArea>
      </Vertical>
      <TextWrapper className={classNames({ translate: true })}>
        <Title>{title}</Title>
        {!!subtitle && <Subtitle color="var(--c-nd-600)">{subtitle}</Subtitle>}
      </TextWrapper>
    </Root>
  );
};
